import mainnetConfig from "./mainnetConfig";
import testnetConfig from "./testnetConfig";
let NetworkConfig = testnetConfig;
if (process.env.REACT_APP_ISMAINNET === "true") {
  NetworkConfig = mainnetConfig;
}

export default NetworkConfig;
